import {Map, logger} from './utils';

class Dictionaries {

    dictionaries: Map<string, Map<string, string>>; // language : (source: target)
    // [dictionaries: string] : [string]; // language : (source: target)

    currentLanguage: string;

    constructor(dictionaries: Map<string, Map<string, string>>, currentLanguage: string) {
        this.dictionaries = dictionaries;
        this.currentLanguage = currentLanguage;
    }

    trans(s: string): string {
        let dict = this.dictionaries[this.currentLanguage];
        if (dict) {
            let target = dict[s];
            if (target) {
                return target;
            } else {
                logger(s);
                return s;
            }
        } else {
            logger(s);
            return s;
        }

    }

    addDictionaries(dictionaries: Map<string, Map<string, string>>): void {
        // dictionaries
        for (let key in dictionaries) {
            if (key !== undefined) {
                this.dictionaries[key] = dictionaries[key];
            }
        }
        // for (let [key, value] of dictionaries) {
        //     this.dictionaries[key] = value;
        // }

    }

    changeLanguage(language: string): void {
        this.currentLanguage = language;
    }

    getLanguages(): Array<string> {
        let output: Array<string> = [];

        for (let key in this.dictionaries) {
            if (key !== undefined) {
                output.push(key)
            }
        }
        return output;
    }
}

let dictionaries: Map<string, Map<string, string>> =
    {
        "ru": {
            "Text Editor": "Редактор Текста",
            "Enter Text": "Введите Текст",
            "Font Size": "Размер Шрифта",
            "Font Color": "Цвет Шрифта",
            "Align": "Выравнивание",
            "Font Family": "Шрифт",
            "Bold": "Жирный",
            "off": "выкл",
            "on": "вкл",
            "Load background": "Загрузить фон",
            "Add static text": "Добавить статический текст",
            "Text": "Текст",
            "Remove": "Удалить",
            "Load image for background": "Загрузить изображение на фон",
            "Load": "Загрузить",
            "Close": "Закрыть",
            "left": "Слева",
            "center": "По центру",
            "right": "Справа",

            "Filters Apply": "Применить фильтры",
            "Settings": "Настройки",
            "Table count": "Кол-во таблиц",
            "Rows count": "Кол-во строк",
            "Save changes": "Сохранить настройки",
            "Column": "Столбец",
            "Show": "Показывать",


            "Control point": "Контрольная точка",
            "Choose...": "Выбрать",
            "Show by": "Показывать по",
            "athletes": "атлетов",


            "Distance": "Дистанция",
            "distance": "Дистанция",
            "Generate Messages": "Генерировать сообщения",
            "Bib": "Номер",
            "Full Name": "ФИО",
            "Phone": "Телефон",
            "Chip time": "Персональное время",
            "Result": "Результат",
            "Gun time": "Время по гану",
            "Message": "Сообщение",
            "Status": "Статус",
            "Progress": "Прогресс",
            "Error": "Ошибка",
            "Request error send": "Ошибка запроса отправки",
            "Request error status": "Ошибка запроса статуса",
            "Sms sending progress": "Прогресс отправки SMS",

            "MENU": "МЕНЮ",
            "Sort by": "Сортировать по",
            "Sort direction": "Направление сортировки",
            "APPLY": "ПРИМЕНИТЬ",
            "Show by ": "Показывать по ",
            " rows on page": " строк на странице",
            "APPLY FILTERS": "ПРИМЕНИТЬ ФИЛЬТРЫ",
            "Search by last name, first name or bib": "Поиск по фамилии, имени или номеру",
            "bib": "номер",
            "Start": "Старт",
            "Finish": "Финиш",
            "Number of rows": "Количество строк",
            "Search": "Поиск",

            "SETTINGS": "НАСТРОЙКИ",
            "Text size": "Размер текста",
            "Text size for template ": "Размер текста для шаблона",
            "FULL SCREEN": "ПОЛНЫЙ ЭКРАН",
            "Full screen": "Полный экран",
            "In width": "По ширине",
            "Gender": "Пол",

            "Ascending": "По возрастанию",
            "Descending": "По убыванию",


            "Update delay in seconds": "Задержка обновления в секундах",
            "Template": "Шаблон",
            "Styles": "Стили",
            "Update delay ": "Задержка обновления ",
            " sec.": " сек.",
            "mono 1": "моно 1",
            "classic 1": "классика 1",

        }
    };


export const dicts = new Dictionaries(dictionaries, "ru");


export function trans(s: string): string {
    return dicts.trans(s);
}

export function changeLanguage(lang: string): void {
    dicts.changeLanguage(lang)
}

dicts.addDictionaries(dictionaries);
